export default "__VITE_ASSET__BXGHsyD5__"